import { gql } from 'urql';

const GetPlaidAccountLinkTokenV2 = gql`
  mutation GetPlaidAccountLinkTokenV2($input: PlaidAccountLinkTokenV2Input!) {
    plaidAccountLinkTokenV2(input: $input) {
      __typename
      ... on PlaidAccountLinkToken {
        expirationDate
        linkReferenceId
        linkToken
      }
    }
  }
`;

export default GetPlaidAccountLinkTokenV2;
